var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{ref:"selectionWrapper",staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('canvas',{ref:"select",attrs:{"id":"canvas","width":_vm.adjustedWidth,"height":_vm.adjustedHeight},on:{"mousedown":_vm.startSelect,"mousemove":_vm.drawRect,"mouseup":_vm.stopSelect,"click":_vm.selectFace}})])
}
var staticRenderFns = []

export { render, staticRenderFns }